/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReservedBloodProductsInterruptAliases {
  DATE_FIELD = 'date-field',
  DATE_INPUT = 'date-input',
  DISCARDED_VOLUME_FIELD = 'discarded-volume-field',
  DISCARDED_VOLUME_INPUT = 'discarded-volume-input',
  INFUSED_VOLUME_FIELD = 'infused-volume-field',
  INFUSED_VOLUME_INPUT = 'infused-volume-input',
  INTERRUPT_FORM = 'interrupt-form',
  MAIN_CONTENT_PANEL = 'main-content-panel',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  PARTIAL_VOLUME_FIELD = 'partial-volume-field',
  PARTIAL_VOLUME_INPUT = 'partial-volume-input',
  PAUSE_TIME_FIELD = 'pause-time-field',
  PAUSE_TIME_INPUT = 'pause-time-input',
  REASON_AUTOCOMPLETE = 'reason-autocomplete',
  REASON_FETCH = 'reason-fetch',
  REASON_FIELD = 'reason-field',
  REASON_MAPPER = 'reason-mapper',
  REASON_TEXT = 'reason-text',
  RESERVED_BLOOD_PRODUCTS_INTERRUPT = 'reserved-blood-products-interrupt',
  SCHEDULE_DATE_FIELD = 'schedule-date-field',
  SCHEDULE_DATE_INPUT = 'schedule-date-input',
  STAGE_VOLUME_FIELD = 'stage-volume-field',
  STAGE_VOLUME_INPUT = 'stage-volume-input',
  TITLE_FIELD = 'title-field',
  TITLE_PANEL = 'title-panel',
  TITLE_TEXT = 'title-text',
}
export { ReservedBloodProductsInterruptAliases };
